var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDistributedEdgeNetwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730",
    transform: "translate(-298 -1539)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_360",
    "data-name": "Rectangle 360",
    width: 58,
    height: 58,
    transform: "translate(298 1539)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M308.607,1555.843a6.133,6.133,0,1,1,6.134-6.134A6.141,6.141,0,0,1,308.607,1555.843Zm0-9.988a3.854,3.854,0,1,0,3.854,3.854A3.859,3.859,0,0,0,308.607,1545.855Z",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M327,1555.843a6.133,6.133,0,1,1,6.134-6.134A6.141,6.141,0,0,1,327,1555.843Zm0-9.988a3.854,3.854,0,1,0,3.854,3.854A3.859,3.859,0,0,0,327,1545.855Z",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M345.393,1555.843a6.133,6.133,0,1,1,6.134-6.134A6.14,6.14,0,0,1,345.393,1555.843Zm0-9.988a3.854,3.854,0,1,0,3.854,3.854A3.859,3.859,0,0,0,345.393,1545.855Z",
    fill: "#847dff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M308.607,1574.134a6.134,6.134,0,1,1,6.134-6.134A6.141,6.141,0,0,1,308.607,1574.134Zm0-9.988a3.854,3.854,0,1,0,3.854,3.854A3.859,3.859,0,0,0,308.607,1564.146Z",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M327,1574.134a6.134,6.134,0,1,1,6.134-6.134A6.141,6.141,0,0,1,327,1574.134Zm0-9.988a3.854,3.854,0,1,0,3.854,3.854A3.859,3.859,0,0,0,327,1564.146Z",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M345.393,1574.134a6.134,6.134,0,1,1,6.134-6.134A6.141,6.141,0,0,1,345.393,1574.134Zm0-9.988a3.854,3.854,0,1,0,3.854,3.854A3.859,3.859,0,0,0,345.393,1564.146Z",
    fill: "#847dff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M308.607,1592.424a6.133,6.133,0,1,1,6.134-6.133A6.14,6.14,0,0,1,308.607,1592.424Zm0-9.988a3.854,3.854,0,1,0,3.854,3.855A3.859,3.859,0,0,0,308.607,1582.436Z",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M327,1592.424a6.133,6.133,0,1,1,6.134-6.133A6.14,6.14,0,0,1,327,1592.424Zm0-9.988a3.854,3.854,0,1,0,3.854,3.855A3.859,3.859,0,0,0,327,1582.436Z",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M345.393,1592.424a6.133,6.133,0,1,1,6.134-6.133A6.14,6.14,0,0,1,345.393,1592.424Zm0-9.988a3.854,3.854,0,1,0,3.854,3.855A3.859,3.859,0,0,0,345.393,1582.436Z",
    fill: "#847dff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361",
    "data-name": "Rectangle 361",
    width: 2.28,
    height: 16.617,
    transform: "translate(329.47 1553.718) rotate(-45)",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_362",
    "data-name": "Rectangle 362",
    width: 16.617,
    height: 2.28,
    transform: "translate(329.469 1563.855) rotate(-44.991)",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_363",
    "data-name": "Rectangle 363",
    width: 2.28,
    height: 15.711,
    transform: "translate(311.524 1554.003) rotate(-45)",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_364",
    "data-name": "Rectangle 364",
    width: 15.711,
    height: 2.28,
    transform: "translate(311.523 1563.499) rotate(-44.991)",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_365",
    "data-name": "Rectangle 365",
    width: 2.28,
    height: 15.711,
    transform: "translate(330.182 1572.661) rotate(-45)",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_366",
    "data-name": "Rectangle 366",
    width: 15.711,
    height: 2.28,
    transform: "translate(330.181 1582.157) rotate(-44.991)",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    "data-name": "Rectangle 367",
    width: 2.28,
    height: 15.711,
    transform: "translate(311.382 1572.376) rotate(-45.001)",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    "data-name": "Rectangle 368",
    width: 15.711,
    height: 2.28,
    transform: "translate(311.381 1581.872) rotate(-44.991)",
    fill: "#847dff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributedEdgeNetwork);
export default __webpack_public_path__ + "static/media/distributed-edge-network.a3267c0e6ecc62c718f83dcf5e4b9b81.svg";
export { ForwardRef as ReactComponent };